exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-postal-code-search[data-v-048de907]{cursor:pointer}.link-postal-code-search:hover small[data-v-048de907]{text-decoration:underline}", ""]);

// exports
